package com.iptvplayer.shared.data.remote.api

import com.iptvplayer.shared.data.remote.dto.*
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import com.iptvplayer.shared.util.Constants

class DeviceApi(private val client: HttpClient) {
    suspend fun getDevices(): List<DeviceDto> =
        client.get("${Constants.BASE_URL}/api/devices").body()

    suspend fun registerDevice(request: RegisterDeviceRequestDto): DeviceDto =
        client.post("${Constants.BASE_URL}/api/devices") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun renameDevice(deviceId: String, name: String): DeviceDto =
        client.put("${Constants.BASE_URL}/api/devices/$deviceId") {
            contentType(ContentType.Application.Json)
            setBody(RenameDeviceRequestDto(name))
        }.body()

    suspend fun removeDevice(deviceId: String): SuccessResponseDto =
        client.delete("${Constants.BASE_URL}/api/devices/$deviceId").body()

    suspend fun sendHeartbeat(deviceId: String): SuccessResponseDto =
        client.post("${Constants.BASE_URL}/api/devices/$deviceId/heartbeat").body()
}
